module.exports = __webpack_public_path__ + "static/media/client-logo-27.b5716dba.jpg";